import { createAction } from '@reduxjs/toolkit';

import { AccountsEntityCountInterface } from '../../models';

export const accountsEntityCountOnSendingRequest = createAction('accountsEntityCount/onSendingRequest');
export const accountsEntityCountOnReceived = createAction<AccountsEntityCountInterface[]>(
  'accountsEntityCount/onReceived'
);
export const accountsEntityCountOnFailed = createAction<string>('accountsEntityCount/onFailed');
